import { Activity } from "./activity";

export class SubActivity extends Activity{
	public tyreInfoRequired:boolean = false;
	subActivity:string = "";

	public constructor(data:any){
		super(data);
		this.tyreInfoRequired = data.tyreInfoRequired;
		this.subActivity = data.subActivity;
	}
}